<template>
    <div>
        <page-header pageTitle="ALLOTMENT.INDEX_TITLE" has-slot>
            <template #container>
                <div class="d-flex flex-row ">
                    <div class="card mt-2 mr-2 card-hover-scale dashboard-summary-card"
                         @click="chooseAllotmentDashboard" title="Dashboard"
                         v-if="allotQtd && this.$hasPermission('Allotment_dashboard')"
                    >
                        <div class="p-2 pl-3 pr-3 d-flex flex-row justify-content-between">
                            <div class="align-self-center">
                                <span><h5>{{ allotQtd }}</h5> </span>
                                <p style="font-size: smaller; font-weight: 600">Loteamentos</p>
                            </div>
                            <div class="d-flex flex-row-reverse">
                                <svg class="apexcharts-svg" transform="translate(0, 0)" width="170" height="50">
                                    <g class="apexcharts-inner apexcharts-graphical" transform="translate(30, -5)">
                                        <defs>
                                            <filter id="SvgjsFilter1075" filterUnits="userSpaceOnUse" width="100%"
                                                    height="150%">
                                                <feOffset id="SvgjsFeOffset1068" result="offset" in="SourceGraphic"
                                                          dx="1"
                                                          dy="1"></feOffset>
                                                <feGaussianBlur id="SvgjsFeGaussianBlur1069" result="blur" in="offset"
                                                                stdDeviation="2"></feGaussianBlur>
                                                <feFlood id="SvgjsFeFlood1070" result="flood" in="SourceGraphic"
                                                         flood-color="#000000" flood-opacity="0.5"></feFlood>
                                                <feComposite id="SvgjsFeComposite1071" result="shadow" in="flood"
                                                             in2="blur"
                                                             operator="in"></feComposite>
                                                <feMerge id="SvgjsFeMerge1072" result="SvgjsFeMerge1072"
                                                         in="SourceGraphic">
                                                    <feMergeNode id="SvgjsFeMergeNode1073" result="SvgjsFeMergeNode1073"
                                                                 in="shadow"></feMergeNode>
                                                    <feMergeNode id="SvgjsFeMergeNode1074" result="SvgjsFeMergeNode1074"
                                                                 in="SourceGraphic"></feMergeNode>
                                                </feMerge>
                                            </filter>
                                        </defs>
                                        <g>
                                            <g>
                                                <path
                                                        d="M 0 44C 5.1722222222222225 44 9.605555555555556 43 14.777777777777779 43C 19.950000000000003 43 24.383333333333333 49 29.555555555555557 49C 34.72777777777778 49 39.16111111111111 26.5 44.333333333333336 26.5C 49.50555555555556 26.5 53.93888888888889 34 59.111111111111114 34C 64.28333333333333 34 68.71666666666667 28 73.8888888888889 28C 79.06111111111112 28 83.49444444444445 43 88.66666666666667 43C 93.8388888888889 43 98.27222222222224 22.5 103.44444444444446 22.5C 108.61666666666667 22.5 113.05000000000001 29.5 118.22222222222223 29.5C 123.39444444444445 29.5 127.82777777777778 15.5 133 15.5"
                                                        fill="none" fill-opacity="1" stroke="rgba(255,255,255,0.85)"
                                                        stroke-opacity="1" stroke-linecap="butt" stroke-width="3"
                                                        stroke-dasharray="0" class="apexcharts-line" index="0"
                                                        clip-path="url(#gridRectMaskssa0k9x6)"
                                                        filter="url(#SvgjsFilter1075)"
                                                        pathTo="M 0 44C 5.1722222222222225 44 9.605555555555556 43 14.777777777777779 43C 19.950000000000003 43 24.383333333333333 49 29.555555555555557 49C 34.72777777777778 49 39.16111111111111 26.5 44.333333333333336 26.5C 49.50555555555556 26.5 53.93888888888889 34 59.111111111111114 34C 64.28333333333333 34 68.71666666666667 28 73.8888888888889 28C 79.06111111111112 28 83.49444444444445 43 88.66666666666667 43C 93.8388888888889 43 98.27222222222224 22.5 103.44444444444446 22.5C 108.61666666666667 22.5 113.05000000000001 29.5 118.22222222222223 29.5C 123.39444444444445 29.5 127.82777777777778 15.5 133 15.5"
                                                        pathFrom="M 0 50 L 0 50 L 14.777777777777779 50 L 29.555555555555557 50 L 44.333333333333336 50 L 59.111111111111114 50 L 73.8888888888889 50 L 88.66666666666667 50 L 103.44444444444446 50 L 118.22222222222223 50 L 133 50"
                                                        fill-rule="evenodd"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class=" mt-2  d-flex flex-row pl-2" style=" border-radius: 15px;"
                         :class="allotQtd ? 'card pr-3' : ''">
                        <div class="align-self-center mr-2">
                            <div class="custom-search" v-if="!widthMd(500)">
                                <input type="text" class="search-query" v-model="searchI" placeholder="Pesquisar"
                                       @keypress="emitWithEnter($event)">
                                <i class="icon-search1" @click="index(searchI)"></i>
                            </div>
                        </div>
                        <div class="align-self-center mr-2"
                             v-if="this.$hasPermission('Allotment_create') && this.hasPermissionShowBd()">
                            <div class="btn-group">
                                <a class="btn btn-custom bg-btn" data-toggle="modal" data-target="#customModalTwo"
                                   @click="setRegisterModal" id="new" data-cy="btn-new-page-header">
                                    <i class="icon-circle-with-plus"></i> {{ t('ACTIONS.NEW') }}
                                </a>
                                <button
                                        class="btn btn-custom bg-btn dropdown-toggle dropdown-toggle-split"
                                        type="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        data-cy="btn-new-dropdown-toggle"
                                >
                                    <span class="sr-only">Toggle Dropdown</span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item pointer app-facilita-dropdown-item" href="/"
                                       data-toggle="modal" data-target="#appFacilitaModal"
                                       @click.prevent="openAppFacilitaModal"
                                       data-cy="btn-new-dropdown-option-appfacilita">
                                        <i class="icon-circle-with-plus mr-2"></i>
                                        <img height="42"
                                             src="https://cdn.appfacilita.com/_uploads/companies/emaislote/configurations/brandLogo.png"
                                             alt="AppFacilita">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </page-header>
        <div class="row gutters" v-if="items && items?.data">
            <div v-for="iten in items?.data" :key="iten.id" class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <figure class="user-card pt-3">
                    <div class="d-flex flex-row justify-content-end">
                        <div class="mr-1  mb-2">
                            <router-link v-if="this.$hasPermission('User_create')" :to="'/cronograma/' + iten.id">
                                <button class="btn btn-outline-primary rounded"><i
                                        class="icon-schedule mr-1"></i>{{ t('TIMELINE.TIMELINE') }}
                                </button>
                            </router-link>
                        </div>
                        <div class="mr-1  mb-2">
                            <div v-if="iten.url_site" @click="openMap(iten.url_site)">
                                <button class="btn btn-outline-primary rounded"><i
                                        class="icon-map2 mr-1"></i>{{ t('ACTIONS.MAP') }}
                                </button>
                            </div>
                        </div>
                        <div class="mb-2">
                            <router-link v-if="this.$hasPermission('User_create')"
                                         :to="'/dashboard-loteamento/' + iten.id" data-cy="allotment_dashboard">
                                <button class="btn btn-outline-primary rounded"><i class="icon-show_chart mr-1"></i>Dashboard
                                </button>
                            </router-link>
                        </div>
                        <div>
                            <a type="button" class="btn edit-card" data-toggle="dropdown" aria-haspopup="true"
                               aria-expanded="false" style="font-size: 20px" id="listDropdown">
                                <i class="icon-more_vert"></i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right dropdown-allotment dropdown-black w-auto"
                                 id="dropdownMenu">
                                <div class="dropdown-item text-white"
                                     v-if="this.$hasPermission('Allotment_create')">
                                    <a class=" pointer text-white" href="Modelo para Importação Usuário.xlsx"
                                       download>
                                        <i class="icon-arrow-with-circle-down mr-2 font-15"/>{{
                                            t('ALLOTMENT.DOWNLOAD_FILE_EXEMPLE')
                                        }}
                                    </a>
                                </div>
                                <div class="dropdown-item pointer text-white" data-target="#customModalTwo"
                                     data-toggle="modal"
                                     v-if="this.$hasPermission('User_create')" @click="setBrokersModal(iten)">
                                    <i class="icon-people mr-2 font-15"/>{{ t('ALLOTMENT.BROKERS') }}
                                </div>
                                <div class="dropdown-item pointer text-white" @click="copy(iten.id)"
                                     v-if="iten.total > 0"
                                     data-cy="allotment_copy_link">
                                    <i class="icon-copy mr-2 font-15"/>{{ t('GENERAL.MSG.COPY_PUBLIC_LINK') }}
                                </div>
                                <div class="dropdown-item pointer text-white" @click="copyLinkClient(iten.id)"
                                     data-cy="allotment_copy_link_person">
                                    <i class="icon-people_outline mr-2 font-15"/>Copiar link de cadastro de clientes
                                </div>
                                <router-link class="dropdown-item pointer text-white"
                                             v-if="this.$hasPermission('Allotment_create')"
                                             :to="'/cronograma/' + iten.id">
                                    <i class="icon-schedule mr-2 font-15"/>{{ t('TIMELINE.TIMELINE') }}
                                </router-link>
                                <div class="dropdown-item pointer text-white" @click="showAlert(iten.id)"
                                     v-if="this.$hasPermission('Allotment_delete') && iten.total == 0"
                                     data-cy="allotment_index_delete">
                                    <i class="icon-delete mr-2 font-15"/>{{ t('ACTIONS.DELETE') }}
                                </div>
                                <div class="dropdown-item pointer text-white" data-target="#customModalTwo"
                                     data-toggle="modal" data-cy="edit-alotment"
                                     @click="setEditModal(iten.id)" v-if="this.$hasPermission('Allotment_update')">
                                    <i class="icon-mode_edit mr-2 font-15"/>{{ t('ACTIONS.EDIT') }}
                                </div>
                                <div class="dropdown-item pointer text-white" data-target="#customModalTwo"
                                     data-toggle="modal"
                                     @click="sendLinkClient(iten.id)"
                                     v-if="this.$hasPermission('Allotment_update')">
                                    <i class="icon-send mr-2 font-15"/>Enviar link de cadastro de pessoas aos
                                    usuários
                                </div>
                                <div class="dropdown-item pointer text-white" @click="exportUsers(iten.id)"
                                     v-if="this.$hasPermission('User_create')">
                                    <i class="icon-download mr-2 font-15"/>Exportar usuários via XLSX
                                </div>
                                <div class="dropdown-item pointer text-white" @click="exportImobi(iten.id)"
                                     v-if="this.$hasPermission('User_create')">
                                    <i class="icon-download mr-2 font-15"/>Exportar Imobiliárias via XLSX
                                </div>
                                <div class="dropdown-item pointer text-white" @click="openUpload(iten.id)"
                                     v-if="this.$hasPermission('User_create')">
                                    <i class="icon-folder_open mr-2 font-15"/>Importar corretores via XLSX
                                </div>
                                <div class="dropdown-item pointer text-white" @click="getLinkUserPublic(iten.id)"
                                     v-if="this.$hasPermission('User_create')">
                                    <i class="icon-user-plus mr-2 font-15"/>Link de cadastro de Corretores
                                </div>
                                <div v-if="iten.url_site" class="dropdown-item pointer text-white"
                                     @click="openMap(iten.url_site)">
                                    <i class="icon-map2 mr-2 font-15"/>{{ t('ACTIONS.MAP') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <figcaption>
                        <img alt="Logo Loteamento" style="margin: auto;" class="profile mb-2" :src="iten.image"
                             v-if="iten.image">
                        <h5 :title="iten.name">{{ iten.name.substring(0, 30) }}</h5>
                        <div v-if="this.$hasPermission('Allotment_create') && this.hasPermissionShowBd()"
                             style="font-size: 10px; color: #3a424c; text-align: center">{{
                                iten.id
                            }}
                        </div>
                        {{ iten?.cities?.name ? iten?.cities?.name + ' - ' + iten?.cities?.states?.name : '' }}
                    </figcaption>
                    <div v-if="iten.total > 0" style="margin-bottom: -1rem">
                        <div :id="iten.id"></div>
                    </div>
                </figure>
            </div>
        </div>
        <div class="card" v-if="items && !items?.data[0]">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('GENERAL.MSG.NO_REGISTER', {name: t('ALLOTMENT.INDEX_TITLE'), os: t('os')}) }}</h5>
                </div>
            </div>
        </div>
        <div class="row gutters">
            <div  class="col-12">
                <pagination-component v-if="items?.data" :items="items" :to="'/loteamento'"
                                      :have-per-page="!widthMd(1000)"
                                      :per-page="perPage"
                                      :paginate="paginate"
                                      @changePaginate="changePaginate"
                                      @changePage="index(filter, $event)"></pagination-component>
            </div>

        </div>
        <app-facilita-modal
                v-bind="appFacilitaModalProps"
                :search-term="searchTerm"
                @update:searchTerm="searchTerm = $event"
                @select-credential="selectCredential"
                @back="backToCredentials"
                @toggle-all="toggleAllEmpreendimentos"
                @clear-selected="clearSelectedEmpreendimentos"
                @toggle-empreendimento="toggleEmpreendimento"
                @import-selected="importEmpreendimentosSelecionados"
        />
        <upload-modal :uploadFile="uploadFile" @upload="uploadFile = $event"
                      @import="importFile($event)"></upload-modal>

        <modal :modal-extra-large="modalSelected !== '3' && modalSelected !== 4 && modalSelected !== '5'"
               :modal-large="modalSelected === '3' || modalSelected === 4 || modalSelected === '5'"
               :titleModal="modalTitle" v-if="modalSelected" @close="closeModal">
            <template v-slot:title>{{ modalTitle }}</template>
            <create-allotment v-if="allotment && modalSelected === '1'" :allotmentIndex="allotment" :isEdit="isEdit"
                              @created="afterCreate" ref="creatAllot"
                              @logo="cropper($event)">
            </create-allotment>
            <show-brokers v-if="modalSelected === '2'" :allotmentIndex="allotment"></show-brokers>
            <modalSendLinkPerson v-if="modalSelected === '3'"
                                 :allotment-id="allotmentSendLinkUser"></modalSendLinkPerson>
        </modal>
    </div>
</template>

<script>

import {mapState} from 'vuex';
import {useI18n} from 'vue-i18n';
import User from '@/services/user';
import Modal from '@/components/modal';
import logo from '@/../public/logo.png';
import ApexCharts from 'apexcharts';
import widthMd from '../../mixins/widthMd';
import {useToast} from 'vue-toastification';
import Allotments from '@/services/Allotments';
import Validate from '@/components/validate.vue';
import ShowBrokers from './showBrokersComponent.vue';
import pageHeader from '@/components/layouts/pageHeader';
import uploadModal from '@/components/layouts/uploadModal';
import CreateAllotment from './createAllotmentComponent.vue';
import PaginationComponent from '../../components/layouts/PaginationComponent';
import jwt_decode from 'jwt-decode';
import modalSendLinkPerson from './partials/modalSendLinkPerson';
import Dashboard from '../../services/Dashboard';
import Public from '../../services/Public';
import AppFacilita from '../../services/AppFacilita';
import integrationCredentials from '@/services/integrationCredentials';
import AppFacilitaModal from './partials/appFacilitaModal.vue';
import Clients from '../../services/Clients';

export default {
    name: 'indexAllotment',
    mixins: [Validate, widthMd],
    components: {
        Modal,
        pageHeader,
        uploadModal,
        CreateAllotment,
        ShowBrokers,
        PaginationComponent,
        modalSendLinkPerson,
        AppFacilitaModal,
    },
    beforeRouteLeave(to, from, next) {
        if (!this.chart) {
            return next();
        } else {
            this.chart.forEach(item => item.destroy());
            this.chart = [];
            return next();
        }
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },
    data() {
        return {
            allotmentModal: '',
            allotmentSendLinkUser: null,
            allotQtd: null,
            perPage: null,
            id: null,
            searchI: null,
            filter: null,
            name: [],
            chart: [],
            items: null,
            modalSelected: null,
            modalTitle: '',
            allotment: null,
            uploadFile: null,
            allotment_id: null,
            isEdit: null,
            hasIndexPermission: false,
            publicLot: window.location.host,
            empreendimentos: [],
            empreendimentosLoading: false,
            empreendimentosError: null,
            selectedEmpreendimentos: [],
            showCredentialPicker: true,
            credentials: [],
            credentialsLoading: false,
            credentialsError: null,
            selectedCredentialId: '',
            searchTerm: '',
            registeredExternalReferences: [],
            importandoEmpreendimentos: false,
        };
    },
    computed: {
        ...mapState({
            menssageAllotmentRequired: 'menssageAllotmentRequired',
            paginate: 'paginate',
            allotments: 'allotments',
        }),
        filteredEmpreendimentos() {
            const term = (this.searchTerm || '').toLowerCase().trim();
            if (!term) return this.empreendimentos;
            return this.empreendimentos.filter((item) => {
                const searchBase = [
                    item.nome,
                    item.code,
                    item.title,
                    item.subtitle,
                    item.city,
                    item.uf,
                    item.status,
                ].join(' ').toLowerCase();
                return searchBase.includes(term);
            });
        },
        eligibleFilteredEmpreendimentos() {
            return this.filteredEmpreendimentos.filter(item => !item.already_registered);
        },
        allFilteredEmpreendimentosSelected() {
            if (!this.eligibleFilteredEmpreendimentos.length) return false;
            return this.eligibleFilteredEmpreendimentos.every(item => this.selectedEmpreendimentos.includes(item.id));
        },
        registeredEmpreendimentosCount() {
            return this.empreendimentos.filter(item => item.already_registered).length;
        },
        selectedCredentialName() {
            const selected = this.validCredentials.find(item => item.id === this.selectedCredentialId);
            return selected ? selected.name : '';
        },
        canSwitchCredential() {
            return this.validCredentials.length > 1;
        },
        validCredentials() {
            return this.credentials.filter(item => this.isCredentialValid(item));
        },
        firstIdConfiguracaoBd() {
            const source = Array.isArray(this.allotments) && this.allotments.length
                    ? this.allotments
                    : (this.items?.data || []);
            const found = source.find(item => Number(item?.id_configuracao_bd) > 0);
            return found ? found.id_configuracao_bd : '';
        },
        appFacilitaModalProps() {
            return {
                showCredentialPicker: this.showCredentialPicker,
                credentialsLoading: this.credentialsLoading,
                validCredentials: this.validCredentials,
                selectedCredentialId: this.selectedCredentialId,
                credentialsError: this.credentialsError,
                selectedCredentialName: this.selectedCredentialName,
                canSwitchCredential: this.canSwitchCredential,
                empreendimentosLoading: this.empreendimentosLoading,
                filteredEmpreendimentos: this.filteredEmpreendimentos,
                allFilteredEmpreendimentosSelected: this.allFilteredEmpreendimentosSelected,
                selectedEmpreendimentos: this.selectedEmpreendimentos,
                empreendimentos: this.empreendimentos,
                registeredEmpreendimentosCount: this.registeredEmpreendimentosCount,
                empreendimentosError: this.empreendimentosError,
                importandoEmpreendimentos: this.importandoEmpreendimentos,
                formatEnvironmentLabel: this.formatEnvironmentLabel,
                formatDate: this.formatDate,
            };
        },
        appFacilitaModalListeners() {
            return {
                'select-credential': this.selectCredential,
                back: this.backToCredentials,
                'toggle-all': this.toggleAllEmpreendimentos,
                'clear-selected': this.clearSelectedEmpreendimentos,
                'toggle-empreendimento': this.toggleEmpreendimento,
                'import-selected': this.importEmpreendimentosSelecionados,
            };
        },
    },
    mounted() {
        this.$canAccess('Allotment_index');
        this.$store.commit('changeLoading', true);
        this.index();
        this.fromLots();
        if (this.$hasPermission('User_create')) this.getQtdAllotment();
    },
    methods: {
        chooseAllotmentDashboard() {
            let id = this.allotments.find(i => i).id;
            this.$router.push({name: 'DashboardAllotment', params: {id}});
        },
        getQtdAllotment() {
            Dashboard.getQtdAllotment(localStorage.getItem('companyId')).then((resp) => {
                this.allotQtd = resp.data?.allotments?.total;
            });
        },
        openAppFacilitaModal() {
            this.searchTerm = '';
            this.selectedEmpreendimentos = [];
            this.openCredentialPicker();
        },
        openCredentialPicker() {
            this.showCredentialPicker = true;
            this.empreendimentos = [];
            this.empreendimentosError = null;
            this.selectedEmpreendimentos = [];
            this.fetchCredentials();
        },
        normalizeExternalReference(value) {
            if (value === null || value === undefined) return null;
            if (typeof value === 'object') {
                const nested = value?.id ?? value?.value ?? value?.external_reference_id ?? value?.code;
                return nested !== null && nested !== undefined ? String(nested) : null;
            }
            return String(value);
        },
        buildRegisteredSet(list) {
            const registeredSet = new Set();
            if (!Array.isArray(list)) return registeredSet;
            list.forEach((item) => {
                const raw = item?.external_reference ?? item?.externalReference ?? item?.external_reference_id;
                const normalized = this.normalizeExternalReference(raw);
                if (normalized) registeredSet.add(normalized);
            });
            return registeredSet;
        },
        async fetchCredentials() {
            this.credentialsLoading = true;
            this.credentialsError = null;
            this.credentials = [];
            this.selectedCredentialId = '';

            try {
                const resp = await AppFacilita.listarCredenciais({
                    integration_key: 'appfacilita',
                    perpage: 50,
                });
                const list = resp?.data?.data || resp?.data?.validations?.data || resp?.data || [];
                this.credentials = Array.isArray(list) ? list : [];

                const validList = this.credentials.filter(item => this.isCredentialValid(item));
                if (!validList.length) {
                    return;
                }

                if (validList.length === 1) {
                    this.selectCredential(validList[0].id);
                    return;
                }

                const storedId = localStorage.getItem('appFacilitaCredentialId');
                const stored = validList.find(item => item.id === storedId);
                if (stored) {
                    this.selectCredential(stored.id);
                    return;
                }
            } catch (e) {
                this.credentialsError = 'Não foi possível carregar as credenciais do AppFacilita.';
                this.toast.error(this.credentialsError, {timeout: false});
            } finally {
                this.credentialsLoading = false;
            }
        },
        isCredentialValid(credential) {
            if (!credential) return false;
            if (credential.status !== 'active') return false;
            return credential?.last_validation_result?.status === 'success';
        },
        selectCredential(id) {
            this.selectedCredentialId = id;
            localStorage.setItem('appFacilitaCredentialId', id);
            this.showCredentialPicker = false;
            this.fetchEmpreendimentos();
        },
        backToCredentials() {
            this.showCredentialPicker = true;
            this.empreendimentos = [];
            this.empreendimentosError = null;
            this.selectedEmpreendimentos = [];
        },
        async fetchEmpreendimentos() {
            this.empreendimentosLoading = true;
            this.empreendimentosError = null;
            try {
                const [empreendimentosResp, allotmentsResp] = await Promise.all([
                    AppFacilita.listarEmpreendimentos({
                        credential_id: this.selectedCredentialId || undefined,
                    }),
                    Allotments.listWithoutBoolean().catch(() => null),
                ]);
                const allotmentsList = allotmentsResp?.data?.data || allotmentsResp?.data?.validations?.data || allotmentsResp?.data || [];
                const registeredSet = this.buildRegisteredSet(allotmentsList);
                this.registeredExternalReferences = Array.from(registeredSet);

                const resp = empreendimentosResp;
                const list = resp?.data?.data || resp?.data?.validations?.data || resp?.data || [];
                this.empreendimentos = Array.isArray(list)
                        ? list.map((item, index) => {
                            const itemId = item?.id ?? item?.empreendimento_id ?? item?.codigo ?? `idx-${index}`;
                            const fileRelations = item?.cover?.files_relational || [];
                            const w350 = fileRelations.find(rel => rel.alias === 'w350')?.url;
                            const h200 = fileRelations.find(rel => rel.alias === 'h200')?.url;
                            const square200 = fileRelations.find(rel => rel.alias === 'square_200')?.url;
                            const normalizedItemId = this.normalizeExternalReference(itemId);
                            const apiAlreadyRegistered = item?.already_registered ?? item?.alreadyRegistered ?? false;
                            const alreadyRegistered = apiAlreadyRegistered || (normalizedItemId ? registeredSet.has(normalizedItemId) : false);
                            return {
                                id: itemId,
                                nome: item?.nome || item?.name || item?.titulo || `Empreendimento ${index + 1}`,
                                code: item?.code || item?.codigo || '',
                                status: item?.status || '',
                                title: item?.infos?.title || '',
                                subtitle: item?.infos?.subtitle || '',
                                stage: item?.infos?.stage || '',
                                blocks: item?.infos?.blocks || '',
                                quantity: item?.quantity || '',
                                city: typeof item?.city === 'object' ? (item?.city?.name || '') : (item?.city || ''),
                                uf: typeof item?.uf === 'object' ? (item?.uf?.name || item?.uf?.uf || '') : (item?.uf || ''),
                                available: item?.availability_summary?.available ?? 0,
                                reserved: item?.availability_summary?.reserved ?? 0,
                                sale: item?.availability_summary?.sale ?? 0,
                                imageUrl: w350 || h200 || square200 || item?.cover?.url || item?.file_relational_w350 || item?.file_relational_h200 || '',
                                already_registered: alreadyRegistered,
                                raw: item,
                            };
                        })
                        : [];
                this.selectedEmpreendimentos = this.selectedEmpreendimentos.filter((id) => {
                    const normalizedId = this.normalizeExternalReference(id);
                    return normalizedId ? !registeredSet.has(normalizedId) : false;
                });
            } catch (e) {
                this.empreendimentos = [];
                this.empreendimentosError = e?.response?.data?.validations?.message ||
                        e?.response?.data?.message ||
                        'Não foi possível carregar os empreendimentos do AppFacilita.';
                this.toast.error(this.empreendimentosError, {timeout: false});
            } finally {
                this.empreendimentosLoading = false;
            }
        },
        formatEnvironmentLabel(env) {
            if (env === 'production') return 'Produção';
            if (env === 'sandbox') return 'Sandbox';
            return env || '-';
        },
        formatDate(value) {
            if (!value) return '-';
            return new Date(value).toLocaleString('pt-BR');
        },
        toggleEmpreendimento(empreendimento) {
            if (empreendimento?.already_registered) return;
            const id = empreendimento?.id;
            if (id === null || id === undefined) return;
            if (this.selectedEmpreendimentos.includes(id)) {
                this.selectedEmpreendimentos = this.selectedEmpreendimentos.filter(selectedId => selectedId !== id);
                return;
            }
            this.selectedEmpreendimentos = [...this.selectedEmpreendimentos, id];
        },
        toggleAllEmpreendimentos() {
            const filteredIds = this.eligibleFilteredEmpreendimentos.map(item => item.id);
            if (!filteredIds.length) return;

            if (this.allFilteredEmpreendimentosSelected) {
                this.selectedEmpreendimentos = this.selectedEmpreendimentos.filter(id => !filteredIds.includes(id));
                return;
            }

            this.selectedEmpreendimentos = Array.from(new Set([...this.selectedEmpreendimentos, ...filteredIds]));
        },
        clearSelectedEmpreendimentos() {
            this.selectedEmpreendimentos = [];
        },
        importEmpreendimentosSelecionados() {
            const selectableIds = this.selectedEmpreendimentos.filter((id) => {
                const empreendimento = this.empreendimentos.find(item => item.id === id);
                return empreendimento && !empreendimento.already_registered;
            });
            if (!selectableIds.length) {
                this.toast.warning('Selecione ao menos um empreendimento disponível para importar.', {timeout: false});
                return;
            }
            if (!this.selectedCredentialId) {
                this.toast.error('Selecione uma credencial AppFacilita.', {timeout: false});
                return;
            }

            const idConfiguracaoBd = this.firstIdConfiguracaoBd;
            if (!idConfiguracaoBd) {
                this.toast.error('Não foi possível identificar id_configuracao_bd.', {timeout: false});
                return;
            }

            this.importandoEmpreendimentos = true;
            integrationCredentials.importAppFacilita({
                external_reference: selectableIds,
                integration_credential_id: this.selectedCredentialId,
                id_configuracao_bd: idConfiguracaoBd,
            }).then((resp) => {
                document.getElementById('closeAppFacilitaModal')?.click();
                const message = resp?.data?.message || 'Importação iniciada. Aguarde alguns instantes para processar os empreendimentos.';
                this.toast.info(message);
                this.selectedEmpreendimentos = [];
            }).catch((error) => {
                const message = error?.response?.data?.message || 'Falha ao enviar a importação.';
                this.toast.error(message, {timeout: false});
            }).finally(() => {
                this.importandoEmpreendimentos = false;
            });
        },
        emitWithEnter(log) {
            if (log.key == 'Enter') {
                this.index(this.searchI);
            }
        },
        sendLinkClient(id) {
            this.modalTitle = 'Eviar  link de cadastro de pessoas aos usuários';
            this.modalSelected = '3';
            this.allotmentSendLinkUser = id;
        },
        async copyLinkClient(id) {
            this.$store.commit('changeLoading', true);
            await Public.getUuidUserByExtenalId(jwt_decode(localStorage.getItem('access_token')).idUsuario).then(async resp => {
                let userId = resp.data;
                let link = `${window.location.protocol}//${window.location.host}/cliente-publico/${localStorage.getItem('companyId')}/${userId}/${id}`;
                await Public.getLinkCut(link).then(resp => {
                    this.$store.commit('changeLoading', false);
                    navigator.clipboard.writeText(resp.data.link).then(() => {
                        this.toast.success('Link de acesso ao cadastro de clientes na área pública foi copiado sucesso');
                    });
                }).catch(() => this.$store.commit('changeLoading', false));
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        exportImobi(allotmentId){
            this.$store.commit('changeLoading', true);
            let filterExport = {allotmentId: allotmentId, onlyImobi: true}
            Clients.exportFile(filterExport).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'imobiliarias.xlsx');
                link.click();
            }).finally(() => this.$store.commit('changeLoading', false));
        },
        exportUsers(allotmentId) {
            this.$store.commit('changeLoading', true);
            User.exportUsersAlotment(allotmentId).then((resp) => {
                this.$store.commit('changeLoading', false);
                this.downloadFile(resp.data, 'usuarios.xlsx');
                this.toast.success('Exportado com sucesso!');
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        downloadFile(blobData, fileName) {
            const url = window.URL.createObjectURL(new Blob([blobData]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        },
        closeModal() {
            this.allotment = null;
            this.modalSelected = null;
        },
        changePaginate(perPage) {
            this.perPage = perPage;
            this.index(this.filter);
        },
        async index(filter = null, page = 1) {
            this.filter = filter;
            this.$store.commit('changeLoading', true);
            await Allotments.index(filter, page, this.perPage).then(resp => {
                if (!resp.data.validations) {
                    this.items = resp.data;
                }
            }).catch(error => {
                this.errorMsg(error);
                this.$store.commit('changeLoading', false);
            });
            this.renderChart();
        },

        renderChart() {
            if (this.chart) {
                this.chart.forEach(item => item.destroy());
                this.chart = [];
            }
            let item = {...this.items?.data};
            for (const key in item) {
                if (item[key]?.total > 0) {
                    let series = [];
                    let label = [];
                    Object.keys(item[key].situations).forEach(i => {
                        label.push(item[key].situations[i]);
                        series.push(item[key].counts[i]);
                    });
                    var options = {
                        series: series,
                        colors: item[key].colors,
                        chart: {
                            type: 'donut',
                            height: '185px',
                            toolbar: {
                                show: true,
                                offsetX: 0,
                                offsetY: 0,
                                tools: {
                                    download: false,
                                    selection: true,
                                    zoom: true,
                                    zoomin: true,
                                    zoomout: true,
                                    pan: true,
                                    reset: true | '<img src="/static/icons/reset.png" width="20">',
                                    customIcons: [],
                                },
                                export: {
                                    csv: {
                                        filename: `${item[key].name}${key}`,
                                        columnDelimiter: ',',
                                        headerCategory: 'category',
                                        headerValue: 'value',
                                        dateFormatter(timestamp) {
                                            return new Date(timestamp).toDateString();
                                        },
                                    },
                                    svg: {
                                        filename: `${item[key].name}${key}`,
                                    },
                                    png: {
                                        filename: `${item[key].name}${key}`,
                                    },
                                },
                                autoSelected: 'zoom',
                            },
                        },
                        responsive: [
                            {
                                breakpoint: 920,
                                options: {
                                    chart: {
                                        width: '310',
                                        height: '250px',
                                    },
                                    legend: {
                                        position: 'bottom',
                                        width: '100%',
                                        offsetY: 0,
                                        offsetX: 50,
                                    },
                                },
                            },
                            {
                                breakpoint: 709,
                                options: {
                                    chart: {
                                        width: '305',
                                        height: '270px',
                                    },
                                    legend: {
                                        position: 'bottom',
                                        width: '100%',
                                        offsetY: 0,
                                        offsetX: 50,
                                    },
                                },
                            },
                            {
                                breakpoint: 630,
                                options: {
                                    chart: {
                                        width: '350',
                                        height: '270px',
                                    },
                                    legend: {
                                        position: 'bottom',
                                        width: '100%',
                                        offsetY: 0,
                                        offsetX: 50,
                                    },
                                },
                            },
                            {
                                breakpoint: 1650,
                                options: {
                                    chart: {
                                        width: '325',
                                        height: '270px',
                                    },
                                    legend: {
                                        position: 'bottom',
                                        width: '100%',
                                        offsetY: 0,
                                        offsetX: 50,
                                    },
                                },
                            }],
                        plotOptions: {
                            pie: {
                                donut: {
                                    labels: {
                                        show: true,
                                        name: {
                                            show: true,
                                            formatter: function (val) {
                                                return val.split('(')[0];
                                            },
                                        },
                                        value: {
                                            fontSize: '14px',
                                            show: true,
                                        },
                                        total: {
                                            fontSize: '14px',
                                            show: true,
                                            color: '#373d3f',
                                        },
                                    },
                                },
                            },
                        },
                        legend: {
                            show: true,
                            fontSize: '14px',
                            horizontalAlign: 'left',
                            offsetY: 20,
                            offsetX: 0,
                        },
                        labels: label,
                    };
                    let el = document.getElementById(item[key].id);
                    let chart = new ApexCharts(el, options);
                    chart.render();
                    this.chart.push(chart);
                }
            }
            this.$store.commit('changeLoading', false);
        },

        openMap(url) {
            window.open(url, '_blank');
        },

        afterCreate() {
            this.index();
            this.$store.dispatch('ActionCheckAllotments', localStorage.getItem('companyId'));
        },

        setEditModal(allotment_id) {
            sessionStorage.setItem('allotmentId', allotment_id);
            this.modalSelected = '1';
            this.isEdit = true;
            this.$store.commit('changeLoading', true);
            Allotments.show(allotment_id).then(resp => {
                this.allotment = resp.data;
                if (!Array.isArray(this.allotment.simulator_configs) || this.allotment.simulator_configs.length === 0)
                    this.allotment.simulator_config_ids = ['1'];
                else this.allotment.simulator_config_ids = this.allotment.simulator_configs?.map(({id}) => id);

                this.allotment.public_area_config_id = this.allotment.public_area_config_id ? this.allotment.public_area_config_id.toString() : '1';
                if (resp.data.financing_interest) {
                    this.allotment.financing_interest = parseFloat(this.allotment.financing_interest).toFixed(4);
                }
                if (resp.data.brokerage_value) {
                    this.allotment.brokerage_value = parseFloat(this.allotment.brokerage_value).toFixed(2);
                }
                if (this.allotment?.id_configuracao_bd > 0) {
                    sessionStorage.setItem('idBD', this.allotment.id_configuracao_bd);
                } else {
                    sessionStorage.removeItem('idBD');
                }
                this.modalTitle = this.t('ALLOTMENT.MODAL_TITLE.EDIT');
                this.$store.commit('changeLoading', false);
            }).finally(() => {
                this.$refs.creatAllot.listSimulatorsConfigurations();
                this.$refs.creatAllot.listPublicAreaConfigurations();
            });
        },
        setBrokersModal(allotment) {
            this.modalTitle = allotment.name;
            this.allotment = allotment;
            this.modalSelected = '2';
        },

        setRegisterModal() {
            this.modalSelected = '1';
            this.isEdit = false;
            this.modalTitle = this.t('ALLOTMENT.MODAL_TITLE.ADD');
            this.allotment = {
                name: '',
                image: logo,
                active: true,
                city_id: null,
                latitude: null,
                url_site: '',
                longitude: null,
                description: '',
                is_required_data_client: false,
                restrict_reserve_to_own_clients: false,
                sync_confirmed_reserve_cvcrm: false,
                financing_interest: null,
                reserve_duration_max: null,
                monetary_correction_indexes_id: null,
                show_allotment_on_public_area: false,
            };
        },
        hasPermissionShowBd() {
            const token = jwt_decode(localStorage.getItem('access_token'));
            return token.login.includes('@r2soft.com.br');
        },
        showAlert(id) {
            this.$swal.fire({
                title: this.t('GENERAL.MSG.REALLY_WANT_DELETE'),
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Excluir`,
                cancelButtonText: 'Cancelar',
            }).then(result => {
                if (result.isConfirmed) {
                    if (id == localStorage.getItem('allotmentId')) {
                        localStorage.removeItem('allotmentId');
                    }

                    Allotments.delete(id).then(() => {
                        document.getElementById('closeX')?.click();
                        this.toast.success(this.t('GENERAL.MSG.DELETED_SUCCESS'));
                        this.$store.dispatch('ActionCheckAllotments', localStorage.getItem('companyId'));
                        this.index();
                    }).catch(error => {
                        this.errorMsg(error);
                        this.$store.commit('changeLoading', false);
                    });
                }
            });
        },

        fromLots() {
            if (this.menssageAllotmentRequired) {
                this.toast.error(this.t('GENERAL.MSG.REQUIRE_ALLOTMENT_REGISTER_FIRST'), {timeout: false});
                this.$store.commit('displayMenssageAllotmentRequired', false);
            }
        },

        getLinkUserPublic(allotmentId) {
            this.$store.commit('changeLoading', true);
            Allotments.getLinkForUser(allotmentId).then((resp) => {
                navigator.clipboard.writeText(resp.data.link)
                        .then(() => this.toast.success('Link de cadastro de Corretores copiado com sucesso, Expira em 1 dia!'));
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },

        copy(allotmentId) {
            localStorage.setItem('publicAllotmentId', allotmentId);
            const link = this.publicLot + '/lote-publico/' + localStorage.getItem('companyId') + '/' + allotmentId;
            navigator.clipboard.writeText(link)
                    .then(() => this.toast.success('Link de acesso ao lote na area publica foi copiado sucesso'));
        },

        cropper(image) {
            this.$store.commit('setImage', image);
            document.getElementById('imageCropper').click();
        },

        openUpload(id) {
            this.uploadFile = true;
            this.allotment_id = id;
        },

        importFile(file) {
            this.$swal.fire({
                title: this.t('GENERAL.MSG.NOTIFY_CORRETORS_IMPORT'),
                icon: 'warning',
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
            }).then(result => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    User.import(file, this.allotment_id, true).then(() => {
                        this.index();
                        this.toast.success(this.t('GENERAL.MSG.USERS_IMPORT_WITH_SUCCESSS'));
                    }).catch(error => this.errorMsg(error)).finally(() => {
                        this.uploadFile = false;
                        this.$store.commit('changeLoading', false);
                    });
                }
                if (result.isDismissed && result.dismiss === 'cancel') {
                    this.$store.commit('changeLoading', true);
                    User.import(file, this.allotment_id).then(() => {
                        this.index();
                        this.toast.success(this.t('GENERAL.MSG.USERS_IMPORT_WITH_SUCCESSS'));
                    }).catch(error => this.errorMsg(error)).finally(() => {
                        this.uploadFile = false;
                        this.$store.commit('changeLoading', false);
                    });
                }
            });
        },
    },
};
</script>

<style>
.right {
    right: 10.5% !important;
}

.tooltip {
    z-index: 1 !important;
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 100px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    bottom: 125%;
    left: 78%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
}

figure.user-card {
    padding: 2rem 1rem 2rem 0rem;
}

.card-focus {
    background: #0e5e4e !important;
    border-bottom: 1px solid #af772b !important;
    opacity: 1 !important;
}

.card-focus i {
    color: #ffffff !important;
}

.dropdown-allotment {
    width: 225px;
    left: 1% !important;
}

</style>
